import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axioKit } from "../../../utilities";

const url = "feedback";

const initialState = {
  collections: [],
  isLoading: false,
  formSubmitted: false,
  isSuccess: false,
  message: "",
};

export const PUBLIC_TESTIMONIALS = createAsyncThunk(
  `${url}/testimonials`,
  (_, thunkAPI) => {
    try {
      return axioKit.universal(`${url}/testimonials`);
    } catch (error) {
      const message = error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const SUBMIT = createAsyncThunk(
  `${url}/save`,
  ({ data }, thunkAPI) => {
    try {
      return axioKit.save(url, data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const reduxSlice = createSlice({
  name: url,
  initialState,
  reducers: {
    RESET: (state) => {
      state.isSuccess = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(PUBLIC_TESTIMONIALS.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(PUBLIC_TESTIMONIALS.fulfilled, (state, action) => {
        state.collections = action.payload;
        state.isLoading = false;
      })
      .addCase(PUBLIC_TESTIMONIALS.rejected, (state, action) => {
        state.isLoading = false;
        state.message = action.error.message;
      })
      .addCase(SUBMIT.pending, (state) => {
        state.formSubmitted = true;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(SUBMIT.fulfilled, (state, action) => {
        state.formSubmitted = false;
        state.isSuccess = true;
        state.message =
          action.payload?.success || "Thank you for your feedback.";
      })
      .addCase(SUBMIT.rejected, (state, action) => {
        state.formSubmitted = false;
        state.isSuccess = false;
        state.message = action.error.message;
      });
  },
});

export const { RESET } = reduxSlice.actions;
export default reduxSlice.reducer;
